import { FiChevronLeft } from 'react-icons/fi';
import { useHistory } from 'react-router';

import { MetaTags } from '@components';

import Feed from './Feed';
import { RightSidebar } from './Sidebar';
import * as S from './styles';

const NewsFeed = () => {
  const history = useHistory();

  return (
    <S.Container>
      <MetaTags title="NewsFeed" />

      <S.PageHeader>
        <S.BackButton type="button" onClick={() => history.goBack()}>
          <FiChevronLeft size="1.375rem" />
        </S.BackButton>
        <h1>NewsFeed</h1>
      </S.PageHeader>

      <S.Wrapper>
        <Feed />
        <RightSidebar />
      </S.Wrapper>
    </S.Container>
  );
};

export default NewsFeed;
